export default __webpack_public_path__ + "static/media/footprint-line.e50c8009.svg";